import Switch from "react-switch";
import PropTypes from "prop-types";

import { selectDarkMode } from "../../state/selectors";
import { getState } from "../../state/store";

import { alignItems, colors } from "../../consts";
import { SwitchTitleWrapper, SwitchWrapper } from "./styled";
import FlexContainers from "../Containers/FlexContainers";

const Switcher = ({ id, title, checked, onSwitch, disabled }) => {
  const darkMode = selectDarkMode()(getState());

  return (
    <SwitchWrapper
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      width={title ? "100%" : "fit-content"}>
      {title && (
        <SwitchTitleWrapper mb={8}>
          <label htmlFor={id}>{title}</label>
        </SwitchTitleWrapper>
      )}

      <Switch
        id={id}
        checked={checked}
        onChange={onSwitch}
        disabled={disabled}
        handleDiameter={28}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 4px rgba(0, 0, 0, 0.25)"
        activeBoxShadow="0px 1px 4px rgba(0, 0, 0, 0.25)"
        width={53}
        height={32}
        onColor={colors.TURQUOISE_100}
        offColor={darkMode ? colors.RAISIN_70 : colors.RAISIN_10}
        onHandleColor={darkMode ? colors.RAISIN_100 : colors.WHITE}
        offHandleColor={darkMode ? colors.RAISIN_100 : colors.WHITE}
      />
    </SwitchWrapper>
  );
};

Switcher.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onSwitch: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Switcher;
